var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliLocationExpandedContent", {
    staticClass: "mt-3",
    attrs: { location: _vm.location, value: _vm.location, icon: null },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }